import React from "react";
import { Button } from "../../general/Button/Button";
import styles from "./SettingRow.module.scss";

interface SettingRowProps {
    label: string;
    value: string | null | undefined;
    buttonText?: string;
    onButtonClick?: () => void;
}

export const SettingRow: React.FC<SettingRowProps> = ({
    label,
    value,
    buttonText,
    onButtonClick,
}) => (
    <div className={styles.settingRow}>
        <div className={styles.data}>
            <span className={styles.label}>{label}</span>
            <span className={styles.value}>{value ?? ""}</span>
        </div>
        {onButtonClick && (
            <Button variant="secondary" onClick={onButtonClick}>
                {buttonText}
            </Button>
        )}
    </div>
);
